module.exports = __webpack_public_path__ + "static/DNY-ead519dad4ee1c6befd1532cf76b81be.png";